import { render } from "./Shipment2SList.vue?vue&type=template&id=2b702480&scoped=true"
import script from "./Shipment2SList.vue?vue&type=script&lang=js"
export * from "./Shipment2SList.vue?vue&type=script&lang=js"

import "./Shipment2SList.vue?vue&type=style&index=0&id=2b702480&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2b702480"

export default script